<template>
    <div class="box">
        <div class="nav">
            <template v-for="(item,index) in nav">
                <a :href="'#'+item" @click='num=index' :class="{'active':(num==index)}">{{item}}</a>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'index',
    props: ['nav'],
    data() {
        return {
            num: 0
        }
    }
}
</script>
<style scoped>
.box{
    background: #fff;
    height: 70px;
    box-shadow: 0 1px 12px rgba(117,140,173,.16);
}
.nav{
    width: 1200px;
    margin: 0 auto;
    font-size: 16px;
    font-weight: bold;
    line-height: 68px;
}
.nav a{
    display: inline-block;
    padding: 0 25px;
    text-align: center;
    color: #303133;
    text-decoration: none;
}
.nav a:hover,.nav a.active{
    color: #1867dd;
    border-bottom: 2px solid #1867dd;
}
</style>